import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"
import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryCustomerCarts = {
  async customerCarts(parent, args, context, info) {
    const { customerId, customerNumber, onlyActive, offset, limit, sort } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.READ,
    })

    const customer = await getCustomer({ number: customerNumber, id: customerId })

    if (!customer) return null

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    let carts = []
    const queryArgs = {
      ...(offset > 0 && { offset }),
      ...(limit > 0 && { limit }),
      ...(sort ? `${sort.orderBy} ${sort.direction}` : null),
      expand: ["customerGroup", "store", "businessUnit", "custom.fields.customerDistributionChannel"],
      where: `customerId="${customer.id}" ${onlyActive ? `and cartState="Active"` : ""}`,
    }

    const commerceApi = CommerceService.api()

    carts = (await commerceApi.carts().get({ queryArgs }).execute())?.body

    carts = carts || {
      limit,
      offset,
      count: 0,
      total: 0,
      items: [],
    }

    if (carts.results instanceof Array) {
      carts.items = carts.results
      delete [carts.results]
    }

    return carts
  },
}
